<div class="flex flex-col">
  <div class="flex flex-col justify-center">
    <p class="font-bold">{{ 'error' | translate }}</p>
    <p>{{ 'messages.invalidLink' | translate }}</p>
    <p>{{ 'messages.callComftech' | translate }}</p>
    <p-button [label]="'goHome' | translate" icon="pi pi-home" size="large" class="m-5" routerLink="/" />
  </div>
</div>
